import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';
import { Privilege } from '@decorator/index';
import { globalValues } from '@app/globals';
import { ContactReportService, ToasterLibraryService, AppConfig, HelpersService } from '@service/index';
import { NgxPermissionsService } from 'ngx-permissions';
import { Logger } from '@service/global.funcs';

@Component({
  selector: 'app-contact-unsold-by-channel-pie-widget',
  templateUrl: './contact-unsold-by-channel-pie-widget.component.html',
  styleUrls: ['./contact-unsold-by-channel-pie-widget.component.scss']
})

// @Privilege({
//   privilege: 'campaigns:can_get_campaigns_reports_sales_per_channel'
// })
export class ContactUnsoldByChannelPieWidgetComponent implements OnInit, OnChanges {
  @Input() relativeDate: any;
  @Input() campaignData: any;
  @Input() criteriaArray: any;
  @Input() formData: any;
  @Input() priceData: any;
  @Input() widgetTitle = 'Leads Unsold by Channel';
  @Input('chartType') chartType = 'pieChart';
  @Input('useTestData') useTestData = false;
  public appContactSoldOptions = AppConfig.contactSoldOptions;

  public contactUnsoldByChannelData = {
    labels: [],
    datasets: [
      {
        data: []
      }
    ],
    totalCount: 0
  };
  testData = {
    labels: ['2015-01-01', '2015-01-02', '2015-01-03', '2015-01-04', '2015-01-05', '2015-01-06', '2015-01-07'],
    datasets: [
      {
        data: [0, 2, 5, 0, 6, 3, 4]
      }
    ],
    totalCount: 7,
  };
  public contactUnsoldByChannelLoaded = false;
  constructor(
    private contactReportService: ContactReportService,
    private permissionService: NgxPermissionsService,
    private toasterLibrary: ToasterLibraryService,
    private helperService: HelpersService
  ) { }

  ngOnInit() {
    if (this.permissionService.hasPermission('campaigns:can_get_campaigns_reports_sales_per_channel')) {
      if (this.useTestData) {
        this.contactUnsoldByChannelData = this.testData;
        this.contactUnsoldByChannelLoaded = true;
      } else {
        this.getContactUnsoldByChannel();
      }
    }
  }
  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if (this.permissionService.hasPermission('campaigns:can_get_campaigns_reports_sales_per_channel')) {
      if (
        (changes['relativeDate'] && !changes['relativeDate'].isFirstChange()) ||
        (changes['campaignData'] && !changes['campaignData'].isFirstChange()) ||
        (changes['criteriaArray'] && !changes['criteriaArray'].isFirstChange()) ||
        (changes['priceData'] && !changes['priceData'].isFirstChange()) ||
        (changes['formData'] && !changes['formData'].isFirstChange())
      ) {
        if (this.useTestData) {
          this.contactUnsoldByChannelData = this.testData;
          this.contactUnsoldByChannelLoaded = true;
        } else {
          this.getContactUnsoldByChannel();
        }
      }
    }
  }

  getContactUnsoldByChannel() {
    const criteriaArray: any = this.getCommonCriteria() || [];
    criteriaArray.push({
      id: '',
      is_required: true,
      criterion: 'soldOption',
      value: {
        sold_option: this.appContactSoldOptions.unsold
      }
    });

    this.contactUnsoldByChannelLoaded = false;
    this.reInit();
    this.contactReportService.getContactsbyChannel(criteriaArray, 'ContactUnsoldByChannelPieWidgetComponent').subscribe(
      (res: any) => {
        if (res.success === 'true') {
          let fifthOptionCount = 0;
          let aggregateIndex = 0;
          res.data.forEach((channel, index) => {
            let cat = channel.channel;

            if (index < globalValues.pie_chart_slices) {
              if (!this.contactUnsoldByChannelData.labels.includes(cat)) {
                this.contactUnsoldByChannelData.labels.push(cat);
                this.contactUnsoldByChannelData.datasets[0].data.push(channel.number_of_occurrences);
              } else {
                aggregateIndex = this.contactUnsoldByChannelData.labels.indexOf(cat);

                this.contactUnsoldByChannelData.datasets[0].data[aggregateIndex] =
                  parseInt(this.contactUnsoldByChannelData.datasets[0].data[aggregateIndex], 10) +
                  parseInt(channel.number_of_occurrences, 10);

                Logger().info(
                  'getSalesByChannel',
                  'pie chart data',
                  'new channel',
                  this.contactUnsoldByChannelData.datasets[0].data[aggregateIndex]
                );
              }
            } else {
              fifthOptionCount = fifthOptionCount + parseInt(channel.number_of_occurrences, 10);
            }
            this.contactUnsoldByChannelData.totalCount =
              this.contactUnsoldByChannelData.totalCount + parseInt(channel.number_of_occurrences, 10);
          });
          if (fifthOptionCount > 0) {
            this.contactUnsoldByChannelData.labels.push('All Other');
            this.contactUnsoldByChannelData.datasets[0].data.push(fifthOptionCount);
          }
        }
        this.contactUnsoldByChannelLoaded = true;
      },
      err => {
        this.toasterLibrary.error(null, err.error.message);
      }
    );
  }

  exportChartData() {
    const orgId = localStorage.getItem("account_id") ?? "0";

    this.contactUnsoldByChannelLoaded = false
    this.helperService.chartCSVDownload(this.contactUnsoldByChannelData, `[${orgId}] ${this.widgetTitle}`)

    setTimeout(() => {
      this.contactUnsoldByChannelLoaded = true
    }, 500);
  }

  private reInit() {
    this.contactUnsoldByChannelData = {
      labels: [],
      datasets: [
        {
          data: []
        }
      ],
      totalCount: 0
    };
  }

  private getCommonCriteria() {
    const criteriaArray: any = [
      {
        is_required: true,
        criterion: 'dateRange',
        value: {
          relative_date: this.relativeDate
        }
      }
    ];

    if (this.campaignData && this.campaignData != "") {
      criteriaArray.push({
        'id': '',
        'value': { c_id: this.campaignData },
        'criterion': 'campaign',
        'is_required': true
      });
    }

    if (this.formData && this.formData != "") {
      criteriaArray.push({
        value: [this.formData],
        criterion: 'form',
        is_required: true,
        id: ''
      });
    }

    if (this.priceData && this.priceData != "") {
      criteriaArray.push({
        value: { rprice_id: this.priceData },
        criterion: 'leadPricing',
        is_required: true,
        id: 0
      });
    }
    return criteriaArray;
  }
}
